<template>
  <div v-for="integration in integrations" :key="integration.id">
    <FacebookPixel
      v-if="integration.provider === 'facebook'"
      :form-id="formId"
      :form-uuid="formUuid"
      :form-name="formName"
      :integration="integration"
    />
  </div>
</template>

<script setup>
import FacebookPixel from "./facebook-pixel.vue";

const props = defineProps({
  formId: {
    type: String,
    required: true,
  },
  formUuid: {
    type: String,
    required: true,
  },
  formName: {
    type: String,
    required: true,
  },
  integrations: {
    type: Array,
    default: () => [],
  },
});
</script>
